module.exports = __webpack_public_path__ + "static/media/s-bahn~ghSEJBWu.13c5a948.svg";